import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";

interface TableStateRowProps {
  colSpan: number;
  state: "loading" | "error" | "empty";
  /** Overrides the default line for the state, e.g. "No recipes found". */
  message?: string;
  /** Error only: shows a Retry button. */
  onRetry?: () => void;
}

const DEFAULT_MESSAGES = {
  loading: "Loading…",
  error: "Couldn't load this list. Check your connection and try again.",
  empty: "Nothing found",
} as const;

/**
 * The one row a list table shows instead of data. A failed request must read
 * as a failure, never as "nothing found" — that is how a timed-out food search
 * once told a doctor there was no milk.
 */
export const TableStateRow = ({
  colSpan,
  state,
  message,
  onRetry,
}: TableStateRowProps) => (
  <TableRow className="hover:bg-transparent">
    <TableCell colSpan={colSpan} className="py-10 text-center">
      {state === "loading" && (
        <Loader2 className="mx-auto mb-2 h-6 w-6 animate-spin text-muted-foreground" />
      )}
      <p
        className={
          state === "error"
            ? "z-body text-destructive"
            : "z-caption text-muted-foreground"
        }
      >
        {message ?? DEFAULT_MESSAGES[state]}
      </p>
      {state === "error" && onRetry && (
        <Button variant="outline" size="sm" className="mt-3" onClick={onRetry}>
          Retry
        </Button>
      )}
    </TableCell>
  </TableRow>
);
